import { useDownloadTemplateMutation } from "../../../../hooks/queries/useBulkUploadsQueries";
import { toastService } from "../../../../providers";
import { extractAxiosErrorMessage } from "../../../../services/utils/errorUtils";

const FALLBACK_FILENAME = "Paykit Disbursement Template.xlsx";

function extractFilename(contentDisposition) {
  const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
  return match?.[1]?.trim() || FALLBACK_FILENAME;
}

function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

export function useTemplateDownload() {
  const { mutate, isPending } = useDownloadTemplateMutation();

  const downloadTemplate = () => {
    mutate(undefined, {
      onSuccess: ({ blob, contentDisposition }) => {
        const filename = extractFilename(contentDisposition);
        triggerBlobDownload(blob, filename);
        toastService.success("Template downloaded successfully.");
      },
      onError: (error) => {
        toastService.error(
          extractAxiosErrorMessage(error, "Failed to download the template. Please try again.")
        );
      },
    });
  };

  return { downloadTemplate, isDownloading: isPending };
}
